import { useState } from 'react';
import './TabNavigation.css';

/**
 * TabNavigation Component
 * Displays three-tab navigation for Live Sessions, PLM Recorded Sessions, and Archived Sessions
 */
const TabNavigation = ({ activeTab, onTabChange, quarterlyEvents, selectedEventDate, onEventDateChange }) => {
  const tabs = [
    { id: 'live', label: 'Live Sessions' },
    { id: 'recommended', label: 'All Segments: Recommended Live Sessions' },
    { id: 'archived', label: 'Archived Sessions' },
  ];

  return (
    <div className="tab-navigation">
      <div className="main-tabs">
        {tabs.map(tab => (
          <div
            key={tab.id}
            className={`tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onTabChange(tab.id);
              }
            }}
          >
            {tab.label}
          </div>
        ))}
      </div>

      {/* Date selector for archived sessions */}
      {activeTab === 'archived' && (
        <div className="date-selector">
          <label htmlFor="event-date-select">Select Archived Event:</label>
          <select
            id="event-date-select"
            value={selectedEventDate || ''}
            onChange={(e) => onEventDateChange(e.target.value)}
          >
            <option value="">-- Select an archived event --</option>
            {quarterlyEvents && quarterlyEvents
              .filter(event => event.status === 'archived')
              .map(event => (
                <option key={event.id} value={event.eventDate}>
                  {event.eventName} ({new Date(event.eventDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })})
                </option>
              ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default TabNavigation;
